<style type="text/css">
    .legendContainer {
        display: flex;
        flex-direction: row;
        position: relative;
        align-items: center;
        margin-bottom: 10px;
    }

    .legendTable {
        min-width: 300px;
        margin-left: 10px;
    }
</style>
<script>
  import { spring } from 'svelte/motion';

  export let values;
  export let radius;
  export let cx;
  export let cy;
  export let showLegend;
  let colors = ["#ef476f","#ffd166","#06d6a0","#118ab2","#073b4c"];

  const getX = (cx, radius, angle) => cx + radius*Math.cos(Math.PI*angle/180);
  const getY = (cy, radius, angle) => cy + radius*Math.sin(Math.PI*angle/180);
  function makeArcPath(cx, cy, radius, startAngle, endAngle) {
    if (endAngle - startAngle === 360) {
      return `
        M ${cx - radius}, ${cy}
          a ${radius},${radius} 0 1,0 ${radius * 2},0
          a ${radius},${radius} 0 1,0 -${radius * 2},0
        `;
    }

    let x1 = getX(cx, radius, startAngle);
    let y1 = getY(cy, radius, startAngle);
    let x2 = getX(cx, radius, endAngle);
    let y2 = getY(cy, radius, endAngle);
    let large = endAngle - startAngle > 180 ? 1:0;
    return `M${cx},${cy} L${x1},${y1} A${radius},${radius} 0 ${large},1 ${x2},${y2} z`
  }

  function pie(vars, cx, cy, radius) {

    // ["#f94144","#f3722c","#f8961e","#f9844a",
    //   "#f9c74f","#90be6d","#43aa8b","#4d908e",
    //   "#577590","#277da1"]

    let sum = vars.map(item => item.value).reduce((prev, cur) => prev + cur)
    let fr = 360/sum;

    let current = -90;
    let angs=[];
    vars.forEach((val, i) => {
      let ang = Math.ceil(val.value * fr)
      angs.push({
        percent: Math.round(val.value/sum*100),
        value: val.value,
        label: val.label,
        valueDisplay: val.valueDisplay,
        arc: makeArcPath(cx, cy, radius, current, current + ang),
        color: colors[i % colors.length]
      })
      current += ang
    });
    return angs;
  }

  let topLeft = new spring({x:0, y:0}, {
    stiffness: 0.1,
    damping: 0.25
  })
  let show;

  function move(e) {
    topLeft.set({
      x: e.clientX + 15,
      y: e.clientY + 10
    });
  }

  let parts = pie(values, cx, cy, radius);
  function setLegend(part) {
    show = `${part.label}:
    ${part.valueDisplay !== undefined ? part.valueDisplay : part.value}
    (${part.percent}%)`
  }

  let legend = parts.map((value,i) => {
    return {
      label: value.label,
      value: value.value,
      valueDisplay: value.valueDisplay,
      percent: value.percent,
      color: colors[i % colors.length]
    }
  });

</script>
<div class="legendContainer">
    <svg style="overflow: visible; width: {radius * 2}px; height: {radius * 2}px;" on:mousedown|preventDefault>
        {#each parts as part}
            <path
                    on:mouseover={() => setLegend(part)}
                    on:focus|preventDefault
                    on:blur
                    on:mouseout={() => show = ''}
                    fill={part.color} d={part.arc}></path>
        {/each}
    </svg>
    {#if showLegend}

        <table class="legendTable">
            {#each legend as row}
                <tr style="max-height: 12px;">
                    <td style="background-color: {row.color}; width: 20px;"></td>
                    <td>{row.label}</td>
                    {#if row.valueDisplay}
                        <td>{row.valueDisplay}</td>
                    {:else}
                        <td>{row.value}</td>
                    {/if}
                    <td style="text-align: right">{row.percent}%</td>
                </tr>
            {/each}
        </table>
    {/if}
</div>


{#if show}
    <div style="position:absolute; left: {$topLeft.x}px;
							top: {$topLeft.y}px; background-color: white;
							padding:10px; border-radius:5px;
							box-shadow: 0 0 1px;
							pointer-events: none">
        {show}
    </div>
{/if}

<svelte:window on:mousemove={move}/>
